import auth from "@profilog/misc/localization/translations/sk/auth.json";
import userSettings from "@profilog/front/localization/translations/sk/userSettings.json";
import userSettingsShared from "@profilog/misc/localization/translations/sk/userSettings.json";
import patients from "@profilog/front/localization/translations/sk/patients.json";
import registration from "@profilog/front/localization/translations/sk/registration.json";
import records from "@profilog/front/localization/translations/sk/records.json";
import aboutService from "@profilog/front/localization/translations/sk/aboutService.json";
import footer from "@profilog/front/localization/translations/sk/footer.json";
import groups from "@profilog/front/localization/translations/sk/groups.json";
import header from "@profilog/front/localization/translations/sk/header.json";
import home from "@profilog/front/localization/translations/sk/home.json";
import loginDisplay from "@profilog/front/localization/translations/sk/loginDisplay.json";
import about from "@profilog/front/localization/translations/sk/about.json";
import aboutUs from "@profilog/front/localization/translations/sk/aboutUs.json";
import useCases from "@profilog/front/localization/translations/sk/useCases.json";
import persons from "@profilog/front/localization/translations/sk/persons.json";
import sharing from "@profilog/front/localization/translations/sk/sharing.json";
import cpz from "@profilog/front/localization/translations/sk/cpz.json";
import obefis from "@profilog/front/localization/translations/sk/obefis.json";
import sps from "@profilog/front/localization/translations/sk/sps.json";
import extConnectors from "@profilog/front/localization/translations/sk/extConnectors.json";
import userInitialization from "@profilog/front/localization/translations/sk/userInitialization.json";
import prescriptions from "@profilog/front/localization/translations/sk/prescriptions.json";
import icudemo from "@profilog/front/localization/translations/sk/icudemo.json";

import apiResult from "@profilog/misc/localization/translations/sk/apiResult.json";
import global from "@profilog/misc/localization/translations/sk/global.json";
import recordsVisualization from "@profilog/misc/localization/translations/sk/recordsVisualization.json";
import caloricsTable from "@profilog/misc/localization/translations/sk/caloricsTable.json";
import apiStatusCheck from "@profilog/misc/localization/translations/sk/apiStatusCheck.json";
import communications from "@profilog/front/localization/translations/sk/communications.json";
import shCommunications from "@profilog/misc/localization/translations/sk/communications.json";
import shNotifications from "@profilog/misc/localization/translations/sk/notifications.json";
import feedback from "@profilog/misc/localization/translations/sk/feedback.json";
import ecg from "@profilog/misc/localization/translations/sk/ecg.json";
import surveys from "@profilog/surveys/localization/translations/sk/surveys.json";
import activitiesVisualization from "@profilog/misc/localization/translations/sk/activitiesVisualization.json";

export default {
    auth,
    userSettings: { ...userSettings, ...userSettingsShared },
    patients,
    registration,
    records,
    recordsVisualization,
    aboutService,
    footer,
    global,
    groups,
    header,
    home,
    loginDisplay,
    about,
    aboutUs,
    apiResult,
    useCases,
    persons,
    sharing,
    cpz,
    obefis,
    sps,
    caloricsTable,
    apiStatusCheck,
    extConnectors,
    userInitialization,
    communications,
    shCommunications,
    shNotifications,
    feedback,
    ecg,
    prescriptions,
    icudemo,
    surveys,
    activitiesVisualization,
};
